/**
 * Avalara © 2017
 * file: engines/opus_ui/src/Menu.js
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Menu.css';
import MenuItem from './MenuItem';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import avalaraLogo from './assets/Avalara_logo.svg';

class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = { searching: this.props.query ? true : false };

    // This binding is necessary to make `this` work in the callback
    this.handleRevealSearch = this.handleRevealSearch.bind(this);
    this.handleCloseSearch = this.handleCloseSearch.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleSearch(input) {
    const { dispatch } = this.props;
    const stringified = queryString.stringify({ query: input.value });
    dispatch(push(`/searchResults?${stringified}`));
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleSearch(e.target);
    }
  }

  handleRevealSearch() {
    this.setState({ searching: true });
  }

  handleCloseSearch() {
    this.setState({ searching: false });
  }

  render() {
    const { items } = this.props;
    const isAuthenticated = this.props.auth.isAuthenticated;

    let menuItems;

    if (isAuthenticated) {
    }
    menuItems = items.map((i, index) => <MenuItem key={index} info={i} />);

    return (
      <div className="Menu">
        <div className="Biztech-logo">
          <Link to="/">
            <img
              src={avalaraLogo}
              alt="Avalara Logo"
              className="Avalara-logo"
            />
            <div className="App-name">OPUS</div>
          </Link>
        </div>
        {menuItems}
      </div>
    );
  }
}

export default connect(({ auth }) => ({ auth }))(Menu);

/*
<Link to="/searchResults">
          <img
             src={`${process.env.PUBLIC_URL}/search.png`}
            className={this.state.searching ? 'search searching' : 'search'}
            onClick={this.handleRevealSearch}
          />
        </Link>
        <input
          ref={input => {
            input && this.state.searching && input.focus();
          }}
          className={this.state.searching ? 'SearchBox searching' : 'SearchBox'}
          placeholder="Search string ..."
          onKeyPress={this.handleKeyPress}
          defaultValue={this.props.query}
        />
        <img
           src={`${process.env.PUBLIC_URL}/close.png`}
          className={
            this.state.searching ? 'CloseSearch searching' : 'CloseSearch'
          }
          onClick={this.handleCloseSearch}
        />
        */
